import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
// styles
import "../../../../assets/saas/atoms/_form-field.scss";
const FormField = ({ type, name, value, placeholder, error, isFocused, onChange, onFocus, onBlur, label, id }) => {
    const { t } = useTranslation();
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            // Blur all input fields on Enter key press
            document.querySelectorAll("input").forEach((input) => input.blur());
        }
    };
    return (_jsx("div", { className: `form-field ${error ? " form--error" : ""}`, children: _jsx("div", { className: `form-field__selected-countary ${error ? "form--error" : ""}`, children: _jsxs("div", { className: "form-field__input-fold", children: [_jsx("label", { className: "form-field__form-label", htmlFor: name, style: isFocused || value ? { display: "block" } : { display: "none" }, children: t(label) }), _jsx("input", { autoComplete: name, className: "form-field__form-input", type: type, placeholder: t(placeholder), inputMode: "text", required: true, value: value, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onKeyDown: handleKeyDown, id: id })] }) }) }));
};
export default FormField;
